import Vue from 'vue'
import BottomSheet from '@webzlodimir/vue-bottom-sheet-vue2'

Vue.component('BottomSheet', BottomSheet)
